<template>
  <v-app id="inspire">
    <Menu style="z-index: 12" v-if="tokenUser != null" />
    <v-main style="height: 100vh">
      <RouterView />
      <!-- Bug Reporter - Only show when logged in -->
    <BugReporter 
      v-if="isAuthenticated"
      :user-info="currentUser"
      :api-endpoint="bugApiEndpoint"
      @bug-reported="onBugReported"
      @error="onBugError"
    />
    </v-main>
  </v-app>
</template>

<script>
import Menu from "./components-admin/Menu.vue";
import BugReporter from "./components/bug-reporter/BugReporter.vue";

export default {
  components: {
    Menu,
    BugReporter
  },
  
  // Use the new WebSocket status watcher
  watchWebSocketStatus: true,
  
  data: () => ({
    tokenUser: null,
  }),
  
  created() {
    this.tokenUser = this.getToken("token");
    this.setupStorageWatchers();
    
    // Make Vue instance globally available for legacy compatibility
    window.vm = this;
  },

  beforeDestroy() {
    // Clean up global reference
    if (window.vm === this) {
      window.vm = null;
    }
  },
  computed: {
    currentUser() {
      // Get current user info from your store/cookies
      return this.$store.getters.user || {
        email: localStorage.getItem('email') || "Unknown",
        role: localStorage.getItem('typeUser') || "Unknown"
      }
    },
    isAuthenticated: function () {
      return this.tokenUser;
    },
    bugApiEndpoint() {
      return process.env.VUE_APP_URL_API_CLIENT + 'save-bug-report/'
    }
  },
  
  methods: {
    onBugReported(response) {
      console.log('Bug report submitted:', response)
    },
    onBugError(error) {
      console.error('Bug report failed:', error)
    },

    /**
     * Setup localStorage watchers for token changes
     */
    setupStorageWatchers() {
      // Enhanced localStorage monitoring
      const self = this;
      
      // Override removeItem
      const originalRemoveItem = localStorage.removeItem;
      localStorage.removeItem = function (key) {
        const event = new Event("removeItem");
        event.key = key;
        document.dispatchEvent(event);
        originalRemoveItem.apply(this, arguments);

        if (key === "token") {
          self.tokenUser = null;
          self.handleTokenRemoved();
        }
      };

      // Override setItem
      const originalSetItem = localStorage.setItem;
      localStorage.setItem = function (key, value) {
        const event = new Event("itemInserted");
        event.value = value;
        event.key = key;
        document.dispatchEvent(event);
        originalSetItem.apply(this, arguments);

        if (key === "token") {
          self.tokenUser = value;
        }
      };

      // Listen for storage events from other tabs
      window.addEventListener('storage', (e) => {
        if (e.key === 'token') {
          const newToken = e.newValue;
          
          if (newToken !== self.tokenUser) {
            self.tokenUser = newToken;
            
            if (!newToken) {
              self.handleTokenRemoved();
            }
          }
        }
      });
    },

    /**
     * Handle token being removed
     */
    handleTokenRemoved() {
      console.log('🔑 Token removed, cleaning up...');
      
      // Clean up user data
      localStorage.removeItem("vendeurName");
      localStorage.removeItem("typeUser");
      
      // WebSocket plugin will automatically disconnect
      
      // Redirect to login
      if (this.$route.name !== 'Login') {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style>
@font-face {
  font-family: "Rubik";
  src: local("Rubik"),
    url("./assets/fonts/Rubik/Rubik-VariableFont_wght.ttf") format("truetype");
}

* {
  font-family: "Rubik";
}
</style>

<style scoped>
.boxed-container {
  max-width: 1440px;
}
</style>